<template>
  <div id="dev-app-wrapper">
    <navbar-menu/>
    <router-view/>
  </div>
</template>

<script>
import NavbarMenu from './components/navbar/Menu';
export default {
  name: 'DevApp',

  components: {
    NavbarMenu,
  },

  data() {
    return {
      // opened: false,
      // opening: false,
    };
  },

  computed: {
    // ...mapGetters({
    //   currentView: 'navigation/getCurrentView',
    // }),
  },

  methods: {
    // open() {
    //   this.opened = true;
    // },
    // close() {
    //   this.opened = false;
    // },
    //
    // beforeEnter() {
    //   this.opening = true;
    // },
    // enter(el, done) {
    //   setTimeout(done, 600);
    // },
    // afterEnter() {
    //   this.opening = false;
    // },
  },
};
</script>

<style lang="scss">
  #dev-app {

  }
</style>
